/**
 * SectionHeader.tsx — seksjonsinnledning som på ibm.com/products
 *
 * Liten versal-etikett (OVERVIEW), stor lettvekts-H2 til venstre og
 * valgfri tekst til høyre. Første seksjon («Overview») bruker blå H2.
 */

import type { ReactNode } from 'react';
import styles from './product.module.css';

interface SectionHeaderProps {
  id: string;
  eyebrow: string;
  heading: string;
  blue?: boolean;
  children?: ReactNode;
}

export default function SectionHeader({ id, eyebrow, heading, blue, children }: SectionHeaderProps) {
  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <p className={styles.eyebrow}>{eyebrow}</p>
        <h2 id={id} className={`${styles.h2} ${blue ? styles.h2Blue : ''}`}>
          {heading}
        </h2>
      </div>
      {children && <div className={styles.headerRight}>{children}</div>}
    </div>
  );
}
